import { APPLICATIONS_ACTION_TYPES } from '@constants/actionTypes/applicationsActionType';

export const INITIAL_STATE = {
    loaded: false,
    householdCaseId: null,
    entities: {}
};

export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case APPLICATIONS_ACTION_TYPES.SET_APPLICATIONS: {
            return {
                loaded: true,
                householdCaseId: action.applications.householdCaseId,
                entities: action.applications
            };
        }
        default:
            return state;
    }
};